<template>
	<div class="sub_contents">
		<div class="cont_center">
			<h1 class="title_page">1:1 문의</h1>
		</div>

		<div class="cont_center">
			<div class="input_area col_2">
				<div>
					<h3 class="title_input">이름</h3>
					<InputText v-model="form.userName" :placeholder="placeholderName" id="userName" />
				</div>

				<div>
					<h3 class="title_input">연락처</h3>
					<InputText v-model="form.phone" :placeholder="placeholderPhone" @input="validatePhoneInput" />
					<p v-if="phoneError" class="error-message">
						휴대폰 번호는 숫자만 입력 가능하며, 10~11자리여야 합니다.
					</p>
				</div>
			</div>

			<div class="input_area col_2">
				<div>
					<h3 class="title_input">이메일</h3>
					<div class="email_area">
						<InputText v-model="emailId" @input="validateEmail" id="email1" /> @
						<InputText v-model="emailDomain" @input="validateEmail" id="email2" />
						<SelectBox :optionName="selectmail" :items="emailList" dropdownId="emailList"
							@itemSelected="handleEmailDomainSelected" />
					</div>
					<p v-if="emailError" class="error-message">
						유효한 이메일 주소를 입력해 주세요.
					</p>
				</div>

				<div>
					<h3 class="title_input">문의 유형</h3>
					<SelectBox :optionName="selectQ" :items="qnaList" dropdownId="qnaList" class="w100"
						@itemSelected="handleQnaTypeSelected" />
				</div>
			</div>

			<div class="input_area">
				<div>
					<h3 class="title_input">제목</h3>
					<InputText v-model="form.qnaTitle" :placeholder="placeholderTitle" />
				</div>
			</div>

			<div class="input_area">
				<div>
					<h3 class="title_input">문의 내용</h3>
					<TextArea v-model="form.qnaRmks" :placeholder="placeholdertextarea"></TextArea>
				</div>
			</div>

			<div class="agree_box">
				<ol class="agree_info_list">
					<li>
						<span>01</span> <strong>수집/이용목적 :</strong> 제휴문의에 따른
						본인확인 및 의사소통 경로 확보
					</li>
					<li>
						<span>02</span> <strong>수집/이용항목 :</strong> 회사명(담당자명),
						메일주소, 전화번호
					</li>
					<li>
						<span>03</span>
						<strong>개인정보 보유 및 이용기간 :</strong> 개인정보 수집 및 이용에
						대한 목적이 달성된 후 해당 정보를 지체 없이 파기
					</li>
				</ol>

				<p class="agree_info_txt">
					※ 그 밖의 사항은 개인정보 처리방침을 준수합니다.
				</p>

				<div class="personal_agree_area">
					<CheckBox v-for="option in checkOptions" :key="option.value" :id="option.value"
						:value="option.value" :label="option.label" v-model="selectedOptions" />
				</div>
			</div>

			<div class="btn_write_area">
				<button type="button" class="btn_type2 inquiry" @click="handleSubmitInquiry">
					<span>?</span> 문의하기
				</button>
			</div>
		</div>
	</div>

	<AlertPopup v-model="alertRequiredShow" title="알림">
		<template #layer_content>
			<p class="alert_txt">
				모든 항목은 필수 항목입니다.<br />
				빠짐없이 기입해 주세요.
			</p>
		</template>
	</AlertPopup>

	<AlertPopup v-model="alertSuccessShow" title="알림">
		<template #layer_content>
			<p class="alert_txt">문의가 성공적으로 제출되었습니다.</p>
			<div class="btn_layer_area">
				<button type="button" class="btn_type1 small" @click="alertSuccessShow = false">확인</button>
			</div>
		</template>
	</AlertPopup>

	<AlertPopup v-model="confirmSubmitShow" title="확인" :customClass="dynamicClass">
		<template #layer_content>
			<p class="alert_txt">
				입력하신 내용으로<br />
				저장하시겠습니까?
			</p>

			<div class="btn_layer_area">
				<button type="button" class="btn_type1 small" @click="handleConfirm">
					확인
				</button>
			</div>
		</template>
	</AlertPopup>
</template>

<script>
import CheckBox from "@/components/CheckBox";
import InputText from "@/components/InputText";
import SelectBox from "@/components/SelectBox";
import TextArea from "@/components/TextArea";
import { postAxios, getAxiosDirect } from "@/lib/AxiosCall";
import AlertPopup from "@/components/AlertPopup.vue";
import { getUserId } from "@/lib/UserInfo";
import { getBranchUuid } from "@/lib/Config";
import { onMounted } from "vue";
import { LOCAL_STORAGE_HVM_USERINFO } from "@/lib/Constant";
import { decryptAES256, safeDecrypt, encryptAES256 } from '@/lib/crypto'; // crypto 유틸리티 import

export default {
	components: {
		CheckBox,
		InputText,
		SelectBox,
		TextArea,
		AlertPopup,
	},
	data() {
		return {
			placeholderName: "이름을 입력하세요.",
			placeholderPhone: "연락처를 입력하세요.(숫자만 입력)",
			placeholderTitle: "제목을 입력하세요.",
			selectmail: "직접 입력",
			emailList: [
				{ name: "네이버", value: "naver.com" },
				{ name: "다음", value: "daum.net" },
				{ name: "지메일", value: "gmail.com" },
				{ name: "직접 입력", value: "" },
			],
			selectQ: "전체",
			qnaList: [
				{ name: "로그인/회원가입", value: "QNA_MEMBER" },
				{ name: "가맹점정보", value: "QNA_STORE" },
				{ name: "결제/카드", value: "QNA_PAYMENT" },
				{ name: "사이트이용", value: "QNA_SITE" },
				{ name: "기타", value: "QNA_ETC" },
			],
			placeholdertextarea: "제휴 문의 내용을 입력하세요.",
			checkOptions: [{ label: "개인정보수집 및 이용 동의", value: "1" }],
			form: {
				userId: getUserId(),
				userName: "",  // name에서 userName으로 통일
				phone: "",
				email: "",
				qnaTitle: "",
				qnaType: "",
				qnaRmks: "",
				agreeYn: "",
			},
			emailId: "",
			emailDomain: "",
			selectedOptions: [],
			alertRequiredShow: false,
			alertSuccessShow: false,
			confirmSubmitShow: false,
			dynamicClass: "confirm",
			phoneError: false,
			emailError: false,
		};
	},
	mounted() {
		// 사용자 데이터 API에서 가져오기 및 초기화
		this.fetchUserDataFromAPI();
	},
	methods: {
		// API에서 사용자 데이터 가져오기 (HFO_MP_005에서 참고)
		async fetchUserDataFromAPI() {
			try {
				const loginInfo = JSON.parse(localStorage.getItem(LOCAL_STORAGE_HVM_USERINFO));

				if (!loginInfo || !loginInfo.userId) {
					console.log('로그인 정보가 없습니다.');
					return;
				}

				console.log('로그인 정보:', loginInfo);
				const encryptedId = encryptAES256(loginInfo.userId);
				const response = await getAxiosDirect("/bgm/v1/auth/search/member", {
					userId: encryptedId
				});

				console.log('API 응답:', response);

				if (response) {
					// 이름 설정
					if (response.userName) {
						this.form.userName = response.userName;
						console.log('설정된 이름:', this.form.userName);
					}

					// 이메일 처리
					const emailValue = response.userEmail;
					if (emailValue && emailValue.includes('@')) {
						const tmpEmail = emailValue.split("@");
						this.emailId = tmpEmail[0] || '';
						this.emailDomain = tmpEmail[1] || '';
						console.log('설정된 이메일 ID:', this.emailId);
						console.log('설정된 이메일 도메인:', this.emailDomain);

						// 이메일 도메인이 목록에 있는지 확인하고 selectmail 업데이트
						const matchedEmailItem = this.emailList.find(item => item.value === this.emailDomain);
						if (matchedEmailItem) {
							this.selectmail = matchedEmailItem.name;
						} else {
							this.selectmail = '직접 입력';
						}
					}

					// 연락처 처리
					const mobileValue = response.userMobile;
					if (mobileValue) {
						// 전화번호 포맷팅 (하이픈 추가)
						this.form.phone = this.formatPhoneForDisplay(mobileValue);
						console.log('설정된 연락처:', this.form.phone);
					}

				} else {
					console.log('사용자 정보를 불러올 수 없습니다.');
				}
			} catch (error) {
				console.error('사용자 데이터 API 호출 오류:', error);
				// 에러가 발생해도 기존 localStorage 정보로 fallback
				this.fallbackToLocalStorage();
			}
		},

		// API 호출 실패시 기존 localStorage 정보 사용
		fallbackToLocalStorage() {
			const loginInfo = JSON.parse(localStorage.getItem(LOCAL_STORAGE_HVM_USERINFO));

			if (loginInfo != null) {
				const tmpEmail = loginInfo.email?.split("@") || [];

				// 이름 설정
				this.form.userName = loginInfo.name || "";
				console.log('fallback - 설정된 이름:', this.form.userName);

				// 이메일 설정
				this.emailId = tmpEmail[0] || "";
				this.emailDomain = tmpEmail[1] || "";
				console.log('fallback - 설정된 이메일 ID:', this.emailId);
				console.log('fallback - 설정된 이메일 도메인:', this.emailDomain);

				// 연락처 설정
				if (loginInfo.phone) {
					this.form.phone = loginInfo.phone;
					console.log('fallback - 설정된 연락처:', this.form.phone);
				}
			}
		},

		// 전화번호 정규화 함수 (HFO_MP_005에서 참고)
		normalizePhoneNumber(phoneNumber) {
			if (!phoneNumber) return '';

			// 공백 제거
			let cleanNumber = phoneNumber.replace(/\s/g, '');

			// +82로 시작하는 경우 (한국 국가코드)
			if (cleanNumber.startsWith('+82')) {
				cleanNumber = cleanNumber.substring(3); // +82 제거

				// 0으로 시작하지 않으면 0 추가
				if (!cleanNumber.startsWith('0')) {
					cleanNumber = '0' + cleanNumber;
				}
			}
			// 82로 시작하는 경우 (국가코드만)
			else if (cleanNumber.startsWith('82') && cleanNumber.length > 10) {
				cleanNumber = cleanNumber.substring(2); // 82 제거

				if (!cleanNumber.startsWith('0')) {
					cleanNumber = '0' + cleanNumber;
				}
			}

			return cleanNumber;
		},

		// 화면 표시용 포맷팅 (하이픈 포함) (HFO_MP_005에서 참고)
		formatPhoneForDisplay(phoneNumber) {
			const normalized = this.normalizePhoneNumber(phoneNumber);
			// 숫자만 추출
			const numbers = normalized.replace(/[^0-9]/g, '');

			// 하이픈 추가하여 포맷팅
			if (numbers.length === 11) {
				// 010-1234-5678 형태
				return numbers.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
			} else if (numbers.length === 10) {
				// 02-1234-5678 또는 031-123-4567 형태
				if (numbers.startsWith('02')) {
					return numbers.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
				} else {
					return numbers.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
				}
			}

			return normalized; // 기본값은 정규화된 번호 반환
		},

		handleSubmitInquiry() {
			console.log('현재 form 상태:', this.form);
			console.log('emailId:', this.emailId, 'emailDomain:', this.emailDomain);
			console.log('selectedOptions:', this.selectedOptions);

			// 각 조건별 체크 - 필드명 통일
			const checks = {
				agreeCheck: !this.selectedOptions.includes("1"),
				titleCheck: !this.form.qnaTitle || this.form.qnaTitle.trim() === "",
				nameCheck: !this.form.userName || this.form.userName.trim() === "",
				phoneCheck: !this.form.phone || this.form.phone.trim() === "",
				contentCheck: !this.form.qnaRmks || this.form.qnaRmks.trim() === "",
				qnaTypeCheck: !this.form.qnaType || this.form.qnaType.trim() === "",
				emailIdCheck: !this.emailId || this.emailId.trim() === "",
				emailDomainCheck: !this.emailDomain || this.emailDomain.trim() === "",
				phoneErrorCheck: this.phoneError,
				emailErrorCheck: this.emailError
			};

			console.log('유효성 검사 결과:', checks);

			// 실패한 조건들 찾기
			const failedChecks = Object.keys(checks).filter(key => checks[key]);
			console.log('실패한 검사 항목들:', failedChecks);

			if (
				!this.selectedOptions.includes("1") ||
				!this.form.qnaTitle || this.form.qnaTitle.trim() === "" ||
				!this.form.userName || this.form.userName.trim() === "" ||
				!this.form.phone || this.form.phone.trim() === "" ||
				!this.form.qnaRmks || this.form.qnaRmks.trim() === "" ||
				!this.form.qnaType || this.form.qnaType.trim() === "" ||
				!this.emailId || this.emailId.trim() === "" ||
				!this.emailDomain || this.emailDomain.trim() === "" ||
				this.phoneError ||
				this.emailError
			) {
				console.log('필수 항목 누락 또는 유효성 검사 실패');
				this.alertRequiredShow = true;
				return;
			}

			console.log('모든 검증 통과, 확인 팝업 표시');
			this.confirmSubmitShow = true;
		},

		// 문의 유형 선택 핸들러 추가
		handleQnaTypeSelected(selectedValue) {
			console.log('선택된 문의 유형:', selectedValue);
			this.form.qnaType = selectedValue;

			// selectQ 업데이트
			const selectedItem = this.qnaList.find(item => item.value === selectedValue);
			if (selectedItem) {
				this.selectQ = selectedItem.name;
			}
		},

		handleEmailDomainSelected(selectedValue) {
			console.log('선택된 이메일 도메인:', selectedValue);
			this.emailDomain = selectedValue;

			// selectmail 업데이트
			if (selectedValue === '') {
				this.selectmail = '직접 입력';
			} else {
				const selectedItem = this.emailList.find(item => item.value === selectedValue);
				this.selectmail = selectedItem ? selectedItem.name : '직접 입력';
			}

			this.validateEmail();
		},

		async handleConfirm() {
			this.confirmSubmitShow = false;

			if (this.phoneError || this.emailError) {
				return;
			}

			try {
				// 이메일과 연락처 암호화
				const fullEmail = `${this.emailId}@${this.emailDomain}`;
				const cleanPhone = this.form.phone.replace(/[^0-9]/g, ''); // 숫자만 추출

				const encryptedEmail = encryptAES256(fullEmail);
				const encryptedPhone = encryptAES256(cleanPhone);

				console.log('암호화 전:', {
					email: fullEmail,
					phone: cleanPhone
				});

				console.log('암호화 후:', {
					email: '암호화된 이메일',
					phone: '암호화된 연락처'
				});

				// API 전송용 데이터 준비
				const requestData = {
					...this.form,
					agreeYn: this.selectedOptions.includes("1") ? "Y" : "N",
					email: encryptedEmail || fullEmail, // 암호화 실패 시 원본 사용
					phone: encryptedPhone || cleanPhone, // 암호화 실패 시 원본 사용
					userId: getUserId(),
				};

				// form.phone도 암호화된 값으로 업데이트 (필요한 경우)
				requestData.phone = encryptedPhone || cleanPhone;

				console.log('전송할 데이터:', {
					...requestData,
					email: '암호화된 이메일',
					phone: '암호화된 연락처'
				});

				const response = await postAxios("/hvm/v1/help/qna", requestData);

				console.log('문의 제출 성공:', response);
				this.alertSuccessShow = true;
				this.resetForm();
			} catch (error) {
				console.error("문의 제출 중 오류 발생:", error);

				// 에러 처리 - 사용자에게 알림
				this.alertContent = "문의 제출 중 오류가 발생했습니다. 다시 시도해주세요.";
				this.alertRequiredShow = true;
			}
		},

		resetForm() {
			this.form = {
				userId: getUserId(),
				userName: "",  // userName으로 통일
				phone: "",
				email: "",
				qnaTitle: "",
				qnaType: "",
				qnaRmks: "",
				agreeYn: "",
			};
			this.selectedOptions = [];
			this.emailId = "";
			this.emailDomain = "";
			this.selectQ = "문의 유형을 선택하세요";
			this.selectmail = "직접 입력";
		},

		validatePhone(phone) {
			// 빈 값인 경우 유효한 것으로 처리 (필수 체크는 별도로)
			if (!phone || phone.trim() === '') {
				return true;
			}
			const phoneRegex = /^[0-9]{10,11}$/;
			return phoneRegex.test(phone);
		},
		validatePhoneInput() {
			// 빈 값인 경우 에러 상태를 false로 설정
			if (!this.form.phone || this.form.phone.trim() === '') {
				this.phoneError = false;
				return;
			}
			this.phoneError = !this.validatePhone(this.form.phone);
			console.log('전화번호 유효성 검사:', this.form.phone, 'Error:', this.phoneError);
		},
		validateEmail() {
			// 둘 중 하나라도 빈 값인 경우 에러 상태를 false로 설정
			if (!this.emailId || !this.emailDomain ||
				this.emailId.trim() === '' || this.emailDomain.trim() === '') {
				this.emailError = false;
				return;
			}
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			this.emailError = !emailRegex.test(`${this.emailId}@${this.emailDomain}`);
			console.log('이메일 유효성 검사:', `${this.emailId}@${this.emailDomain}`, 'Error:', this.emailError);
		},
	},
};
</script>

<style>
.text_input_num {
	margin-top: -17px;
}
</style>
